import React from 'react';
import { motion } from 'framer-motion';
import { hcfCycle } from '../data/pillars';
import { ResearchStatusNote } from './pillars/ResearchStatusNote';
import { fadeUp } from '../utils/motion';
import { cycleRelationship } from '../data/siteContent';

/** The general HCF cycle: how development moves. */
export function OperatingModel() {
  return <section id="hcf-cycle" className="scroll-mt-20 py-20 lg:py-24 bg-surface-bg border-y border-line" data-id="element-1619" data-mp="lifxv997aow0">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1620" data-mp="1i903smrebpqa">
        <motion.div {...fadeUp} className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-16 mb-12" data-id="element-1621" data-mp="1d8u8mwlx3l3g">
          <div className="lg:col-span-5" data-id="element-1622" data-mp="18g168fdx8ouj">
            <p className="text-sm font-medium text-teal mb-3" data-id="element-1623" data-mp="18epyy5l9oyyo">The HCF cycle</p>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-ink-dark leading-tight" data-id="element-1624" data-mp="14f8tvd9r63u1">
              Assess → Review → Develop → Reassess
            </h2>
          </div>
          <p className="lg:col-span-7 lg:pt-8 text-lg text-ink-muted leading-relaxed" data-id="element-1625" data-mp="1w5vgqqarq1bm">
            The Human Capability Framework connects structured exercises, transparent assessment criteria, human
            review and development activities. Every finding leads somewhere: to review, to practice, and to a
            later reassessment.
          </p>
        </motion.div>

        <motion.ol {...fadeUp} aria-label="HCF cycle" className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-line border border-line rounded-lg overflow-hidden" data-id="element-1626" data-mp="yiph798rx6me">
          {hcfCycle.map((item, index) => <li key={item.step} className="bg-white p-6 lg:p-8" data-id="element-1627" data-mp="pggayvkjfzet" data-mpi={index}>
              <span className="block font-heading font-bold text-sm text-teal mb-2" data-id="element-1628" data-mp="an3b7ms58isy">{index + 1}</span>
              <span className="block font-heading font-bold text-2xl text-ink-dark" data-id="element-1629" data-mp="fl51osrwfkeg">{item.step}</span>
              <span className="mt-2 block text-ink-muted leading-relaxed" data-id="element-1630" data-mp="250cn1l85wged">{item.description}</span>
            </li>)}
        </motion.ol>

        <motion.div {...fadeUp} className="mt-10 grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-16" data-id="element-1631" data-mp="28h7aumlm718g">
          <p className="lg:col-span-7 lg:col-start-6 text-ink-dark leading-relaxed" data-id="element-1632" data-mp="23husae1s0gbo">
            {cycleRelationship}{' '}
            <a href="/ncji#pathway" className="font-semibold text-navy underline decoration-line underline-offset-4 hover:text-navy-light transition-colors duration-150" data-id="element-1633" data-mp="1ykcf2bgq7exv">
              See the detailed NCJI development pathway within HCF
            </a>
            .
          </p>
        </motion.div>

        <ResearchStatusNote className="mt-12 max-w-3xl" data-id="element-1634" data-mp="2maylxzezut6a" />
      </div>
    </section>;
}